import axios from 'axios'

export default function useNewTemplates() {
  const fetchUsedTemplates = async () => {
    return await axios
      .get<{
        data: string[]
      }>(`/marketing-flows/used-templates`)
      .then((res) => res.data)
  }

  const usedTemplates = ref<string[]>([])

  const isCustomerBirthdayUsed = computed(() => usedTemplates.value.includes('CustomerBirthday'))
  const isCustomerVipUsed = computed(() => usedTemplates.value.includes('CustomerVip'))
  const isCustomerAtRiskUsed = computed(() => usedTemplates.value.includes('CustomerAtRisk'))

  onMounted(async () => {
    usedTemplates.value = (await fetchUsedTemplates()).data
  })

  return {
    isCustomerBirthdayUsed,
    isCustomerVipUsed,
    isCustomerAtRiskUsed
  }
}
